// components/PoolMobileView.js
import React from "react";
import { Accordion } from "react-bootstrap";
import PoolMobileRow from "./PoolMobileRow";

const PoolMobileView = ({ pools = [], onShare, rootPoolData }) => {
  if (!pools.length) return <p className="nodatttta">No pools available</p>;

  return (
    <div className="parentacc">
      {/* 👇 changed from d-none to d-md-none */}
      <div className="mainacc d-md-none">
        <Accordion alwaysOpen>
          {pools.map((pool, index) => (
            <PoolMobileRow
              key={pool._id || index}
              pool={pool}
              index={index}
              onShare={onShare}
              eventKey={index.toString()}
              rootPoolData ={rootPoolData}
            />
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default PoolMobileView;
